import idb from 'idb';
import { store } from '../vuex/store';

// Reference: https://developers.google.com/web/ilt/pwa/working-with-indexeddb

// need to figure out version control with the separate access points to the DB,
// current references to this store that would also need to keep up with the current version:

( function() {
    'use strict';

    if ( !( 'indexedDB' in window ) ) { // check for support

        console.log( 'WARNING: no indexDB!' );
        alert( 'This browser doesn\'t support IndexedDB!' );
        return;
    }
    console.log( 'indexDb is active..' );

    // var is a more global namespace, used in the functions for cache control
    var timestamp = +( new Date().getTime() );

    // idb.open( name, version, upgradeCallback )
    let dbPromise = idb.open( 'quickOrdersDB', store.getters.idbVersion, upgradeDb => {

        // console.log( 'making a new object store' );
        if ( ! upgradeDb.objectStoreNames.contains( 'menuCategories' ) ) {

            // upgradeDb.createObjectStore( 'storeName', options );
            // upgradeDb.createObjectStore( 'logs', { keyPath: 'id', autoIncrement: true } );
            upgradeDb.createObjectStore(
                'menuCategories',
                {
                    autoIncrement: true
                }
            );
        }

        if ( ! upgradeDb.objectStoreNames.contains( 'menuItems' ) ) {

            upgradeDb.createObjectStore(
                'menuItems',
                {
                    autoIncrement: true
                }
            );
        }

        if ( ! upgradeDb.objectStoreNames.contains( 'menuModifierGroups' ) ) {

            upgradeDb.createObjectStore(
                'menuModifierGroups',
                {
                    autoIncrement: true
                }
            );
        }

        if ( ! upgradeDb.objectStoreNames.contains( 'menuItemModifierGroups' ) ) {

            upgradeDb.createObjectStore(
                'menuItemModifierGroups',
                {
                    autoIncrement: true
                }
            );
        }

        if ( ! upgradeDb.objectStoreNames.contains( 'pastOrders' ) ) {

            upgradeDb.createObjectStore(
                'pastOrders',
                {
                    autoIncrement: true
                }
            );
        }

        if ( ! upgradeDb.objectStoreNames.contains( 'cardWallet' ) ) {

            upgradeDb.createObjectStore(
                'cardWallet',
                {
                    autoIncrement: true
                }
            );
        }

        if ( ! upgradeDb.objectStoreNames.contains( 'inAppMsgs' ) ) {

            upgradeDb.createObjectStore(
                'inAppMsgs',
                {
                    autoIncrement: true
                }
            );
        }

        if ( ! upgradeDb.objectStoreNames.contains( 'pastTransactions' ) ) {

            upgradeDb.createObjectStore(
                'pastTransactions',
                {
                    autoIncrement: true
                }
            );
        }
    });

    dbPromise.then( db => {

        return db.transaction( 'menuItems' )
            .objectStore( 'menuItems' )
            .getAll();
    }).then( items => {

        // console.log( 'items: ', items );
        if( items && items.length > 0 ){

            store.state.orderMenu.quickItems = items;
        }
    }).catch( err => {

        console.log('lol', err );
    });

    dbPromise.then( db => {

        return db.transaction( 'menuCategories' )
            .objectStore( 'menuCategories' )
            .getAll();
    }).then( categories => {

        // console.log( 'categories: ', categories );
        if( categories && categories.length > 0 ){

            store.state.orderMenu.quickCategories = categories;
        }
    });

    dbPromise.then( db => {

        return db.transaction( 'menuModifierGroups' )
            .objectStore( 'menuModifierGroups' )
            .getAll();
    }).then( modGroups => {

        // console.log( 'modifier groups: ', modGroups );
        if( modGroups && modGroups.length > 0 ){

            store.state.orderMenu.quickModifierGroups = modGroups;
        }
    });

    dbPromise.then( db => {

        return db.transaction( 'menuItemModifierGroups' )
            .objectStore( 'menuItemModifierGroups' )
            .getAll();
    }).then( itemModGroups => {

        // console.log( 'itemModGroups: ', itemModGroups );
        if( itemModGroups && itemModGroups.length > 0 ){

            store.state.orderMenu.quickItemModifierGroups = itemModGroups;
        }
    });

    dbPromise.then( db => {

        return db.transaction( 'pastOrders' )
            .objectStore( 'pastOrders' )
            .getAll();
    }).then( orders => {

        // console.log( 'Past Orders: ', orders );
        if( orders.length < 1 ){

            store.state.orders.ordersCached = null;
            localStorage.setItem( 'ordersCached', null );
        } else {

            const cache = localStorage.getItem( 'ordersCached' ) || null;
            if( cache == null ){ // if for some reason they emptied their localStorage.. reset cache to current timestamp

                state.ordersCached = timestamp;
                localStorage.setItem( 'ordersCached', timestamp );
            } else {

                store.state.orders.ordersCached = cache;
            }

            orders.forEach( value => {

                store.state.orders.pastOrders.push( value );
            });
        }
    });

    dbPromise.then( db => {

        return db.transaction( 'cardWallet' )
            .objectStore( 'cardWallet' )
            .getAll();
    }).then( cards => {

        // console.log( 'Card Wallet: ', cards );
        if( cards.length < 1 ){

            store.state.cards.cardsCached = null;
            localStorage.setItem( 'cardsCached', null );
        } else {

            const cache = localStorage.getItem( 'cardsCached' ) || null;
            if( cache == null ){

                store.state.cards.cardsCached = timestamp;
                localStorage.setItem( 'cardsCached', timestamp );
            } else {

                store.state.cards.cardsCached = cache;
            }

            cards.forEach( card => {

                store.state.cards.wallet.push( card );
            })
        }
    });

    dbPromise.then( db => {

        return db.transaction( 'inAppMsgs' )
            .objectStore( 'inAppMsgs' )
            .getAll();
    }).then( msgs => {

        // console.log( 'In App Msgs: ', msgs );
        if( msgs.length < 1 ){

            store.state.inAppMsg.msgsCached = null;
            localStorage.setItem( 'msgsCached', null );
        } else {

            const cache = localStorage.getItem( 'msgsCached' ) || null;
            if( cache == null ){

                store.state.inAppMsg.msgsCached = timestamp;
                localStorage.setItem( 'msgsCached', timestamp );
            } else {

                store.state.inAppMsg.msgsCached = cache;
            }

            msgs.forEach( msg => {

                store.state.inAppMsg.inAppMsgs.push( msg );
            })
        }
    });

    dbPromise.then( db => {

        return db.transaction( 'pastTransactions' )
            .objectStore( 'pastTransactions' )
            .getAll();
    }).then( transactions => {

        // console.log( 'Past Transactions: ', transactions );
        if( transactions.length < 1 ){

            store.state.transactions.transactionsCached = null;
            localStorage.setItem( 'transactionsCached', null );
        } else {

            const cache = localStorage.getItem( 'transactionsCached' ) || null;
            if( cache == null ){

                store.state.transactions.transactionsCached = timestamp;
                localStorage.setItem( 'transactionsCached', timestamp );
            } else {

                store.state.transactions.transactionsCached = cache;
            }

            transactions.forEach( transaction => {

                store.state.transactions.allTransactions.push( transaction );
            })
        }
    });

})();